export enum ShopifyPlan {
  NONE = "none",
  STANDARD = "standard",
  PLUS = "plus",
}

const DEV_STORE_PLAN_NAMES = ["affiliate", "partner_test"];

/**
 * Shopify development stores: the partner "affiliate" / "partner_test" plans,
 * or any plan whose display name contains "Development".
 */
export function isDevStore(team: {
  _shopify?: {
    plan_name?: string | null;
    plan_display_name?: string | null;
  } | null;
}): boolean {
  const planName = team._shopify?.plan_name;
  const planDisplayName = team._shopify?.plan_display_name ?? "";
  return (
    (planName != null && DEV_STORE_PLAN_NAMES.includes(planName)) ||
    planDisplayName.includes("Development")
  );
}
